import { render, staticRenderFns } from "./RouteList.vue?vue&type=template&id=2f56b16d&scoped=true&"
import script from "./RouteList.vue?vue&type=script&lang=js&"
export * from "./RouteList.vue?vue&type=script&lang=js&"
import style0 from "./RouteList.vue?vue&type=style&index=0&id=2f56b16d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f56b16d",
  null
  
)

export default component.exports